module.exports = "/_next/static/images/hollistic-support-1a78bb2b181e2662e45fbade841c7777.svg";